import CreateHabit from "./components/CreateHabit";
import { connect } from "react-redux";
import { createHabit } from "./actionCreators";
import type {
  StateProps,
  DispatchProps,
  OwnProps,
} from "./components/CreateHabit";

const mapStateToProps = (state, ownProps) => {
  return ownProps;
};

const mapDispatchToProps = {
  createHabit,
};
export default connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(CreateHabit);
